// Lib
import { head } from 'lodash/fp';

// Utils
import { getRectCenterPoint, getSimpleBoundingRect } from '../../../../../../common/maths/geometry/rect';

// Constants
import { PoiType } from '../../../poiConstants';

const addTargetPoint = ({ pointer }) => {
    const { targetRect } = pointer;

    // If the group is a corner type, force the pointer to point at the corner
    pointer.targetPoint = getRectCenterPoint(targetRect);

    return pointer;
};

const mergeActivityData = (accPointer, pointer) => {
    accPointer.poiType = PoiType.activity;
    accPointer.data = accPointer.data || { actorIds: [], count: 0 };
    accPointer.data.count += pointer.data.count;

    return accPointer;
};

const mergeSearchData = (accPointer, pointer) => {
    accPointer.poiType = pointer.poiType;
    accPointer.data = accPointer.data || { count: 0 };
    accPointer.data.count += pointer.data.count;

    return accPointer;
};

const mergeData = (accPointer, pointer) => {
    const { poiType } = pointer;

    switch (poiType) {
        case PoiType.search:
            return mergeSearchData(accPointer, pointer);
        default:
            return mergeActivityData(accPointer, pointer);
    }
};

const getMergedGroupId = (pointerIds) => pointerIds.sort().join('_');

const mergePointers = ({ pointerIds, pointersMap }) => {
    if (pointerIds.length === 1) return pointersMap[head(pointerIds)];

    const mergedPointer = pointerIds.reduce((acc, pointerId) => {
        const pointer = pointersMap[pointerId];
        acc.targetRect = acc.targetRect
            ? getSimpleBoundingRect(acc.targetRect, pointer.targetRect)
            : pointer.targetRect;

        return mergeData(acc, pointer);
    }, {});

    mergedPointer.id = getMergedGroupId(pointerIds);

    return addTargetPoint({ pointer: mergedPointer });
};

export default ({ groups, pointersMap }) => groups.map(({ pointerIds }) => mergePointers({ pointerIds, pointersMap }));
